import { lazy } from "react";

const Home = lazy(() => import("../views/app/Home"));

const Jobs = lazy(() => import("../views/app/ATS/Jobs"));

const Applicants = lazy(() => import("../views/app/ATS/Applicants"));

const UserSettings = lazy(() => import("../views/app/Configurations/UserSettings"));
const CompanySettings = lazy(() => import("../views/app/Configurations/CompanySettings"));

const Talents = lazy(() => import("../views/app/CRM/Talents"));
const Talent = lazy(() => import("../views/app/CRM/Talent"));

const Livechat = lazy(() => import("../views/app/Others/Livechat"));
const OauthResponse = lazy(() => import("../views/app/Others/Microsoft/OauthResponse"));

const Error = lazy(() => import("../views/Error"));

export const appRoutes = [
  {
    path: "/app/home",
    element: <Home />,
  },
  {
    path: "/app/jobs",
    element: <Jobs />,
  },
  {
    path: "/app/applicants",
    element: <Applicants />,
  },
  {
    path: "/app/talents",
    element: <Talents />,
  },
  {
    path: "/app/talent",
    element: <Talent />,
  },
  {
    path: "/app/user-settings",
    element: <UserSettings />,
  },
  {
    path: "/app/company-settings",
    element: <CompanySettings />,
  },
  {
    path: "/app/livechat",
    element: <Livechat />,
  },
  {
    path: "/app/microsoft/oauth",
    element: <OauthResponse />,
  },
  {
    path: "/app/error",
    element: <Error />,
    meta: {
      layout: "blank",
    },
  },
];
